import { DateTime } from "luxon";

export const TABLE_DATETIME_HINT = "Times are shown and entered in UTC.";

// An ISO value with no zone is UTC, as the backend stores it (schema.py's
// coerce), not the viewer's local time.
function parse(value: unknown): DateTime {
  const iso = DateTime.fromISO(String(value).replace(" ", "T"), {
    zone: "UTC",
  });
  return iso.isValid
    ? iso
    : DateTime.fromJSDate(new Date(String(value)), { zone: "UTC" });
}

// Must match _DATETIME_DISPLAY in row_filter.py; en-US because en-GB abbreviates September as "Sept".
export function formatTableDatetime(value: unknown): string | null {
  const d = parse(value);
  return d.isValid ? d.setLocale("en-US").toFormat("dd LLL yyyy, HH:mm") : null;
}
